import Component from 'flarum/common/Component';
import app from 'flarum/forum/app';
import Markdown from './Markdown';
import CollapsibleSection from './CollapsibleSection';
import TaroMarkdownEditor from './TaroMarkdownEditor';

export default class TaroCaseModules extends Component {
  oninit(vnode) {
    super.oninit(vnode);
    this.loading = {};
    this._saraFollowUpInput = '';
    this._expandedFollowUp = null;  // AI 追问展开的 id
    this._expandedMentorFollowUp = null;  // 导师追问展开的 id

    // Inline input state
    this.showInterpretationInput = false;
    this.showInterpretationEdit = false;
    this.interpretationInput = '';
    this.showMentorReviewInput = false;
    this.mentorReviewInput = '';
    this.showFeedbackInput = false;
    this.feedbackContent = '';
    this.feedbackRating = '5';
    this.showFollowUpQuestionInput = false;
    this.followUpQuestionInput = '';
    this.showAnswerInputFor = null;  // followUp id
    this.answerInput = '';
    this.mentorReviewRequested = false;
  }

  oncreate(vnode) {
    super.oncreate(vnode);
  }

  view() {
    const taroCase = this.attrs.case;
    if (!taroCase) return null;

    const user = app.session.user;
    const aiReport = taroCase.aiReport();
    const interpretation = taroCase.interpretation();
    const mentorReview = taroCase.mentorReview();
    const feedbacks = taroCase.feedbacks() || [];
    const followUps = taroCase.followUps() || [];

    // AI 追问：过滤出 AI 类型的（先过滤掉 API 返回中可能混入的 undefined）
    const saraFollowUps = followUps.filter((f) => f && f.attribute && f.attribute('target_type') === 'ai');

    // 读取 levelConfigs 获取扣费信息
    const levelConfigs = app.forum.attribute('taroAiLevelConfigs') || {};
    const caseLevel = (taroCase.attribute('requiredLevel') || 'S2').toUpperCase();
    const userLevel = (user && user.attribute('taroSwordLevel')) || 'S1';
    const caseLevelCfg = levelConfigs[caseLevel] || {};
    const userLevelCfg = levelConfigs[userLevel] || levelConfigs['S1'] || {};

    // Store hasMentorReview on instance so renderMyReading can reference it
    this.hasMentorReview = !!mentorReview;

    return (
      <div className="TaroCaseModules">
        {/* 顶部工具栏：4 个并列按钮 */}
        {this.renderToolbar(user, taroCase, aiReport, interpretation)}

        {/* 板块 1：萨拉解读（含 AI 追问） */}
        <CollapsibleSection
          key="sara"
          title="萨拉解读"
          icon={<i className="fas fa-robot"></i>}
          badge={saraFollowUps.length ? saraFollowUps.length + ' 条追问' : (aiReport ? null : '待生成')}
        >
          {this.renderSaraReading(user, taroCase, aiReport, saraFollowUps, caseLevelCfg, caseLevel)}
        </CollapsibleSection>

        {/* 板块 2：我的解读（含导师点评 + 导师追问） */}
        <CollapsibleSection
          key="my-reading"
          title="我的解读"
          icon={<i className="fas fa-user-graduate"></i>}
          badge={this.computeMyReadingBadge(interpretation, mentorReview)}
        >
          <div className="TaroMyMentorStack">
            {this.renderMyReading(user, taroCase, interpretation)}
            {this.renderMentorSection(user, taroCase, mentorReview, followUps)}
          </div>
        </CollapsibleSection>

        {/* 板块 3：反馈信息 */}
        <CollapsibleSection
          key="feedback"
          title="反馈信息"
          icon={<i className="fas fa-comments"></i>}
          badge={feedbacks.length ? feedbacks.length + ' 条' : null}
        >
          {this.renderFeedback(user, taroCase, feedbacks)}
        </CollapsibleSection>
      </div>
    );
  }

  // ============================================================
  // 顶部工具栏（精简版：仅剩余出售按钮，其他功能移至模块内）
  // ============================================================
  renderToolbar(user, taroCase, aiReport, interpretation) {
    const isOwner = user && String(user.id()) === String(taroCase.userId());
    const isForSale = taroCase.attribute('is_for_sale') === true || taroCase.attribute('visibility') === 'public';

    return (
      <div className="TaroToolbar" key="toolbar">
        {isOwner && (
          <button
            className={'Button TaroToolbar-btn TaroToolbar-btn--sell' + (isForSale ? '' : ' highlighted')}
            onclick={() => this._toggleForSale(taroCase)}
            title={isForSale ? '点击查看出售详情' : '设为出售'}
          >
            <i className={'fas ' + (isForSale ? 'fa-shopping-cart' : 'fa-tag')}></i>
            <span>{isForSale ? '已出售' : '出售'}</span>
          </button>
        )}
      </div>
    );
  }

  /** 出售/取消出售（新接口：支持价格，出售后公开，默认私密） */
  _toggleForSale(taroCase) {
    const isForSale = taroCase.attribute('isForSale') === true || taroCase.attribute('is_for_sale') === true;
    const hasAiReport = !!taroCase.aiReport();
    const hasInterpretation = !!taroCase.interpretation();

    if (!isForSale) {
      if (!hasAiReport && !hasInterpretation) {
        alert('出售前需要先完成萨拉解读或发布你的解读。');
        return;
      }

      const raw = prompt('请输入出售价格（星币）：', String(taroCase.attribute('salePrice') || taroCase.attribute('view_price') || 10));
      if (raw === null) return;
      const price = parseInt(raw, 10);
      if (!price || price <= 0) {
        alert('出售价格必须大于 0');
        return;
      }
      if (!confirm('确认以 ' + price + ' 星币出售此案例？出售后案例将公开，其他用户购买时您可获得圣杯分成。')) return;

      this._submitSale(taroCase, true, price);
      return;
    }

    if (!confirm('确认撤回出售并恢复为隐私贴？')) return;
    this._submitSale(taroCase, false, 0);
  }

  _submitSale(taroCase, forSale, price) {
    this.setLoading('visibility', true);
    app.request({
      method: 'PATCH',
      url: this.apiUrl('/taro/cases/' + taroCase.id() + '/sell'),
      body: { data: { attributes: { for_sale: forSale, price } } },
    })
      .then((response) => {
        this.setLoading('visibility', false);
        const attrs = response.data && response.data.attributes ? response.data.attributes : {};
        taroCase.pushAttributes({
          visibility: attrs.visibility || (forSale ? 'public' : 'private'),
          isForSale: forSale,
          is_for_sale: forSale,
          salePrice: price,
          sale_price: price,
        });
        const discussion = this.attrs.case && this.attrs.case.discussion && this.attrs.case.discussion();
        if (discussion) discussion.pushAttributes({ taroCaseVisibility: forSale ? 'public' : 'private' });
        m.redraw();
      })
      .catch((err) => {
        this.setLoading('visibility', false);
        this.handleError(err);
      });
  }

  computeMyReadingBadge(interpretation, mentorReview) {
    const hasMy = !!interpretation;
    const hasMentor = !!mentorReview;
    if (hasMy && hasMentor) return '已解读 · 已点评';
    if (hasMy) return '已解读';
    if (hasMentor) return '导师已点评';
    return '待发布';
  }

  apiUrl(path) {
    return app.forum.attribute('apiUrl') + path;
  }

  setLoading(key, value) {
    this.loading[key] = value;
    m.redraw();
  }

  handleError(err) {
    let message = '操作失败';
    try {
      const data = err.response && err.response.data ? err.response.data : null;
      if (data && data.errors && data.errors[0]) {
        message = data.errors[0].detail || data.errors[0].title || message;
      } else if (err.statusText) {
        message = err.statusText;
      }
    } catch (e) {}
    alert(message);
  }

  // ============================================================
  // 板块 1：萨拉解读（含 AI 追问）
  // ============================================================
  renderSaraReading(user, taroCase, aiReport, saraFollowUps, caseLevelCfg, caseLevel) {
    const isOwner = user && String(user.id()) === String(taroCase.userId());
    const isPurchaser = this._isPurchaser(taroCase, user);
    // 只有案主可以发起萨拉解读，购买者只能查看已有解读
    // 但 AI 追问允许案主和购买者发起
    const canInteract = isOwner;
    const canFollowUp = isOwner || isPurchaser;
    const hasAi = !!aiReport;
    const hasFollowUps = saraFollowUps && saraFollowUps.length > 0;

    // 等级配置（按案例等级显示萨拉身份）
    const sarahColor = caseLevelCfg.sarah_color || '#4CAF50';
    const sarahTitle = caseLevelCfg.sarah_title || '萨拉';
    const sarahBadge = caseLevelCfg.sarah_badge || '';
    // 等级图标从论坛配置读取（集中管理）
    const levelMeta = app.forum.attribute('taroLevelMeta') || {};
    const levelIcons = (levelMeta.sword && levelMeta.sword.icons) || {};
    const levelIcon = levelIcons[caseLevel] || '🃏';
    const interpretCost = caseLevelCfg.interpretCost || 0;
    const followUpCost = caseLevelCfg.followUpCost || 0;

    if (!hasAi) {
      // --- 尚无 AI 解读：显示按钮 ---
      if (this.loading['request-ai']) {
        return (
          <div className="TaroModule-placeholder">
            <div style={{ padding: '16px', background: sarahColor + '08', borderRadius: '8px', border: '1px solid ' + sarahColor + '22', textAlign: 'center' }}>
              <i className="fas fa-spinner fa-pulse" style={{ color: sarahColor, fontSize: '20px', marginBottom: '8px' }}></i>
              <div style={{ color: sarahColor, fontSize: '14px', fontWeight: '600' }}>萨拉正在解读中…</div>
              <div style={{ color: '#999', fontSize: '12px', marginTop: '4px' }}>牌阵信息已发送给萨拉，请耐心等待约 15-30 秒</div>
              {interpretCost > 0 ? (
                <div style={{ color: '#e67e22', fontSize: '13px', marginTop: '6px' }}>本次操作消耗 <strong>{interpretCost}</strong> 星币</div>
              ) : (
                <div style={{ color: '#4CAF50', fontSize: '13px', marginTop: '6px' }}>本次操作免费</div>
              )}
            </div>
          </div>
        );
      }
      return (
        <div className="TaroModule-placeholder">
          <p className="TaroModule-placeholder-text">萨拉尚未对此案例进行解读</p>
          {canInteract && (
            <div>
              <button
                className="Button Button--primary"
                disabled={this.loading['request-ai']}
                onclick={() => this._requestSaraReading(taroCase)}
              >
                  <span><i className="fas fa-magic"></i> 萨拉解读 {interpretCost > 0 ? '(消耗 ' + interpretCost + ' 星币)' : ''}</span>
              </button>
            </div>
          )}
        </div>
      );
    }

    // --- 有 AI 解读 ---
    const content = aiReport.attribute('report_content');
    if (!content) {
      return (
        <div className="TaroModule-private-notice">
          <i className="fas fa-lock"></i> 萨拉解读仅对案主、导师、辅导员可见
        </div>
      );
    }

    return (
      <div className="TaroModule-content">
        {/* Sarah 等级标识 */}
        <div style={{ display: 'flex', alignItems: 'center', gap: '8px', padding: '8px 12px', borderRadius: '8px', background: sarahColor + '15', border: '1px solid ' + sarahColor + '33', marginBottom: '12px' }}>
          <span style={{ fontSize: '20px' }}>{levelIcon}</span>
          <div style={{ flex: 1 }}>
            <span style={{ fontWeight: '700', color: sarahColor, fontSize: '15px' }}>{sarahTitle}</span>
            {sarahBadge && (
              <span style={{ marginLeft: '6px', padding: '1px 8px', borderRadius: '10px', background: sarahColor, color: '#fff', fontSize: '11px', fontWeight: '600' }}>{sarahBadge}</span>
            )}
            <div style={{ fontSize: '12px', color: '#888', marginTop: '1px' }}>
              案例等级：{caseLevel}
            </div>
          </div>
        </div>

        {/* 重新解读按钮（仅案主可操作，有追问时禁用） */}
        {canInteract && (
        <div style={{ marginBottom: '12px' }}>
          <button
            className="Button"
            disabled={this.loading['request-ai'] || hasFollowUps}
            title={hasFollowUps ? '已有追问记录，无法重新发起解读' : (interpretCost > 0 ? '消耗 ' + interpretCost + ' 星币' : '')}
            onclick={() => {
              if (hasFollowUps) {
                alert('已有追问记录，无法重新发起萨拉解读。');
                return;
              }
              this._requestSaraReading(taroCase);
            }}
            style={{ fontSize: '13px' }}
          >
            {this.loading['request-ai'] ? <i className="fas fa-spinner fa-pulse"></i> : <i className="fas fa-magic"></i>}
            {' '}萨拉解读
            {interpretCost > 0 && !this.loading['request-ai'] && <span style={{ marginLeft: '4px', color: '#e67e22', fontSize: '12px' }}>({interpretCost} 星币)</span>}
          </button>
          {hasFollowUps && <span style={{ marginLeft: '8px', fontSize: '12px', color: '#999' }}><i className="fas fa-info-circle"></i> 有追问时不可重新发起解读</span>}
        </div>
        )}

        {/* 生成中提示 */}
        {this.loading['request-ai'] && (
          <div style={{ padding: '16px', background: sarahColor + '08', borderRadius: '8px', border: '1px solid ' + sarahColor + '22', marginBottom: '12px', textAlign: 'center' }}>
            <i className="fas fa-spinner fa-pulse" style={{ color: sarahColor, fontSize: '20px', marginBottom: '8px' }}></i>
            <div style={{ color: sarahColor, fontSize: '14px', fontWeight: '600' }}>萨拉正在解读中…</div>
            <div style={{ color: '#999', fontSize: '12px', marginTop: '4px' }}>牌阵信息已发送给萨拉，请耐心等待约 15-30 秒</div>
            {interpretCost > 0 ? (
              <div style={{ color: '#e67e22', fontSize: '13px', marginTop: '6px' }}>本次操作消耗 <strong>{interpretCost}</strong> 星币</div>
            ) : (
              <div style={{ color: '#4CAF50', fontSize: '13px', marginTop: '6px' }}>本次操作免费</div>
            )}
          </div>
        )}

        {/* AI 解读报告内容 */}
        <Markdown text={content} />
        <div className="TaroModule-meta" style={{ marginBottom: '16px' }}>
          <small>
            生成于 {aiReport.createdAt().toLocaleString()} · 消耗 {aiReport.attribute('star_cost') || 0} 星币
          </small>
        </div>

        {/* AI 追问区块 */}
        {this._renderSaraFollowUps(saraFollowUps, sarahColor, levelIcon, canFollowUp, followUpCost, taroCase)}
      </div>
    );
  }

  /** AI 追问列表 + 输入（点击问题展开/收起答案） */
  _renderSaraFollowUps(followUps, sarahColor, levelIcon, canFollowUp, followUpCost, taroCase) {
    return (
      <div className="TaroAiFollowUp" style={{ borderTop: '1px solid #e8ecf0', paddingTop: '12px', marginTop: '8px' }}>
        <h4 style={{ margin: '0 0 10px', fontSize: '14px', color: '#555', display: 'flex', alignItems: 'center', gap: '6px' }}>
          <i className="fas fa-comment-dots" style={{ color: sarahColor }}></i>
          AI 追问（{followUps.length}）
        </h4>

        {/* 追问列表：一问一答折叠 */}
        {followUps.map((fu) => {
          const id = fu.id();
          const question = fu.attribute('question');
          const answer = fu.attribute('answer');
          const isExpanded = this._expandedFollowUp === id;
          return (
            <div key={id} className="TaroAiFollowUp-item" style={{ marginBottom: '8px', border: '1px solid #e8ecf0', borderRadius: '8px', overflow: 'hidden' }}>
              <div
                className="TaroAiFollowUp-question"
                onclick={() => {
                  this._expandedFollowUp = isExpanded ? null : id;
                  m.redraw();
                }}
                style={{ padding: '10px 14px', background: '#f5f7fa', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', userSelect: 'none' }}
              >
                <span style={{ color: '#555', fontWeight: '600', whiteSpace: 'nowrap' }}>Q:</span>
                <span style={{ flex: 1, color: '#333' }}>{question}</span>
                <span style={{ color: '#999', fontSize: '12px', transition: 'transform 0.2s', transform: isExpanded ? 'rotate(180deg)' : 'none' }}>
                  <i className="fas fa-chevron-down"></i>
                </span>
              </div>
              {isExpanded && answer && (
                <div className="TaroAiFollowUp-answer" style={{ padding: '10px 14px 10px 32px', background: sarahColor + '06', fontSize: '14px', lineHeight: '1.7', borderTop: '1px solid #e8ecf0' }}>
                  <span style={{ color: sarahColor, fontWeight: '600' }}>{levelIcon} A:</span>
                  <div style={{ marginTop: '4px', color: '#444' }}>{answer}</div>
                </div>
              )}
              {isExpanded && !answer && (
                <div style={{ padding: '10px 14px 10px 32px', fontSize: '13px', color: '#999', borderTop: '1px solid #e8ecf0' }}>
                  <i className="fas fa-spinner fa-pulse"></i> 萨拉正在思考…
                </div>
              )}
            </div>
          );
        })}

        {/* 追问输入 */}
        {canFollowUp && (
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginTop: '10px' }}>
            <input
              className="FormControl"
              type="text"
              placeholder={followUpCost > 0 ? '输入追问内容（消耗 ' + followUpCost + ' 星币）…' : '输入你的追问…'}
              value={this._saraFollowUpInput}
              disabled={this.loading['ai-follow-up']}
              onkeydown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  this._submitSaraFollowUp(taroCase);
                }
              }}
              oninput={(e) => { this._saraFollowUpInput = e.target.value; }}
              style={{ flex: 1, fontSize: '14px', borderRadius: '20px', padding: '7px 14px' }}
            />
            <button
              className="Button"
              style={{ backgroundColor: sarahColor, borderColor: sarahColor, color: '#fff', borderRadius: '50%', width: '36px', height: '36px', padding: 0 }}
              disabled={this.loading['ai-follow-up'] || !this._saraFollowUpInput.trim()}
              onclick={() => this._submitSaraFollowUp(taroCase)}
            >
              {this.loading['ai-follow-up'] ? <i className="fas fa-spinner fa-pulse"></i> : <i className="fas fa-paper-plane"></i>}
            </button>
          </div>
        )}
      </div>
    );
  }

  /** 发起/重新发起萨拉解读 */
  _requestSaraReading(taroCase) {
    // 读取案例等级的扣费配置（后端按案例等级扣费）
    const levelConfigs = app.forum.attribute('taroAiLevelConfigs') || {};
    const caseLevel = (taroCase.attribute('requiredLevel') || 'S2').toUpperCase();
    const caseLevelCfg = levelConfigs[caseLevel] || {};
    const interpretCost = caseLevelCfg.interpretCost || 0;

    const costText = interpretCost > 0
      ? '本次操作将消耗 ' + interpretCost + ' 星币。'
      : '本次操作免费。';

    // 已有 AI 解读时：确认覆盖
    let hasExistingReport = false;
    try {
      hasExistingReport = !!taroCase.aiReport();
    } catch (e) {
      hasExistingReport = !!taroCase.attribute('aiReport');
    }

    const self = this;

    if (hasExistingReport) {
      const msg = '再次进行萨拉解读，新的内容会覆盖原内容，原内容将不会被留存。\n\n' + costText + '\n\n确定要继续吗？';
      if (!confirm(msg)) {
        return;
      }
    }

    // 先设置 loading，用双 requestAnimationFrame 确保 DOM 更新后再发请求
    // confirm() 会阻塞事件循环并清空渲染队列，需要特殊处理
    self.loading['request-ai'] = true;

    // 直接操作 DOM 显示 loading（绕过 Mithril 的异步 redraw）
    // 在 Mithril 的 redraw 生效前，先手动插入 loading 提示
    const saraSection = document.querySelector('.TaroModule-content');
    if (saraSection) {
      // 找到重新解读按钮的容器
      const btnContainer = saraSection.querySelector('button[disabled]') ? saraSection.querySelector('button[disabled]').parentElement : null;
      if (btnContainer) {
        const loadingDiv = document.createElement('div');
        loadingDiv.id = 'sara-loading-temp';
        loadingDiv.style.cssText = 'padding:16px;background:' + (caseLevelCfg.sarah_color || '#4CAF50') + '14;border-radius:8px;border:1px solid ' + (caseLevelCfg.sarah_color || '#4CAF50') + '33;margin-bottom:12px;text-align:center;';
        loadingDiv.innerHTML = '<i class="fas fa-spinner fa-pulse" style="color:' + (caseLevelCfg.sarah_color || '#4CAF50') + ';font-size:20px;margin-bottom:8px;"></i>' +
          '<div style="color:' + (caseLevelCfg.sarah_color || '#4CAF50') + ';font-size:14px;font-weight:600;">萨拉正在解读中…</div>' +
          '<div style="color:#999;font-size:12px;margin-top:4px;">牌阵信息已发送给萨拉，请耐心等待约 15-30 秒</div>' +
          (interpretCost > 0
            ? '<div style="color:#e67e22;font-size:13px;margin-top:6px;">本次操作消耗 <strong>' + interpretCost + '</strong> 星币</div>'
            : '<div style="color:#4CAF50;font-size:13px;margin-top:6px;">本次操作免费</div>');
        btnContainer.parentElement.insertBefore(loadingDiv, btnContainer.nextSibling);
        // 禁用按钮
        const btn = btnContainer.querySelector('button');
        if (btn) btn.disabled = true;
      }
    }

    // Mithril redraw（可能在 confirm 后延迟执行）
    m.redraw();

    // 用 setTimeout 确保在事件循环空闲后再发请求
    setTimeout(function() {
      app
        .request({
          method: 'POST',
          url: self.apiUrl('/taro/cases/' + taroCase.id() + '/request-ai'),
          body: hasExistingReport ? { data: { attributes: { force: true } } } : undefined,
        })
        .then(function() {
          self.loading['request-ai'] = false;
          // 移除临时 loading DOM
          const tempDiv = document.getElementById('sara-loading-temp');
          if (tempDiv) tempDiv.remove();
          m.redraw();
          return app.store.find('taro-cases', taroCase.id(), { include: 'aiReport,interpretation,mentorReview,feedbacks,followUps,followUps.user,followUps.answeredBy' });
        })
        .then(function() { m.redraw(); })
        .catch(function(err) {
          self.loading['request-ai'] = false;
          const tempDiv = document.getElementById('sara-loading-temp');
          if (tempDiv) tempDiv.remove();
          m.redraw();
          self.handleError(err);
        });
    }, 100);
  }

  /** AI 追问（走 Path B：持久化到 taro_case_follow_ups） */
  _submitSaraFollowUp(taroCase) {
    const question = this._saraFollowUpInput.trim();
    if (!question || this.loading['ai-follow-up']) return;

    this.loading['ai-follow-up'] = true;
    this._saraFollowUpInput = '';
    m.redraw();

    // 从已有追问记录中取最新的 conversation_id
    const followUps = (taroCase.followUps() || []).filter((f) => f && f.attribute && f.attribute('target_type') === 'ai');
    const lastFollowUp = followUps.length > 0 ? followUps[followUps.length - 1] : null;
    const conversationId = lastFollowUp ? lastFollowUp.attribute('conversation_id') : null;

    app
      .request({
        method: 'POST',
        url: this.apiUrl('/taro/cases/' + taroCase.id() + '/ai-follow-up'),
        body: {
          data: {
            type: 'taro-case-follow-ups',
            attributes: { question, conversationId },
          },
        },
      })
      .then(() => {
        // 请求已返回，AI 可能在后台还在处理——立即刷新数据
        return app.store.find('taro-cases', taroCase.id(), {
          include: 'aiReport,interpretation,mentorReview,feedbacks,followUps,followUps.user,followUps.answeredBy',
        });
      })
      .then(() => {
        this.loading['ai-follow-up'] = false;
        // 如果最新追问还没被回答，启动轮询等待
        const latest = this._getLatestUnansweredFollowUp(taroCase);
        if (latest) {
          this._pollFollowUpAnswer(taroCase, latest.id());
        }
        m.redraw();
      })
      .catch((err) => {
        this.loading['ai-follow-up'] = false;
        this.handleError(err);
      });
  }

  /** 获取最新未回答的 AI 追问 */
  _getLatestUnansweredFollowUp(taroCase) {
    const ais = (taroCase.followUps() || []).filter(
      (f) => f && f.attribute('target_type') === 'ai' && !f.attribute('answer')
    );
    return ais.length > 0 ? ais[ais.length - 1] : null;
  }

  /** 轮询 AI 追问的 answer */
  _pollFollowUpAnswer(taroCase, followUpId) {
    let attempts = 0;
    const maxAttempts = 60; // 最多轮询 60 次（约 60s）
    const poll = () => {
      if (attempts >= maxAttempts) {
        this.loading['ai-follow-up'] = false;
        m.redraw();
        return;
      }
      attempts++;
      app.store
        .find('taro-cases', taroCase.id(), {
          include: 'aiReport,interpretation,mentorReview,feedbacks,followUps,followUps.user,followUps.answeredBy',
        })
        .then(() => {
          const fu = (taroCase.followUps() || []).find((f) => f.id() === followUpId);
          if (fu && fu.attribute('answer')) {
            // AI 已回答
            this.loading['ai-follow-up'] = false;
            // 展开最新追问
            this._expandedFollowUp = followUpId;
            m.redraw();
          } else {
            // 还没回答，1s 后继续轮询
            setTimeout(poll, 1000);
          }
        })
        .catch(() => {
          setTimeout(poll, 2000);
        });
    };
    setTimeout(poll, 1000);
  }

  /** 判断当前用户是否为该案例的购买者 */
  _isPurchaser(taroCase, user) {
    if (!user || !taroCase) return false;
    // 目前前端没有直接判断购买的方式，通过是否有 purchases 关系判断
    const purchases = taroCase.purchases && taroCase.purchases();
    if (purchases && purchases.length > 0) {
      return purchases.some((p) => String(p.userId ? p.userId() : p.attribute('user_id')) === String(user.id()));
    }
    return false;
  }

  // ============================================================
  // 板块 2：我的解读（含导师点评 + 导师追问）
  // ============================================================
  renderMyReading(user, taroCase, interpretation) {
    const isOwner = user && String(user.id()) === String(taroCase.userId());
    const isLocked = taroCase.isInterpretationLocked();

    // --- 还没有解读：显示发布入口 ---
    if (!interpretation) {
      return (
        <div className="TaroModule-placeholder">
          <p className="TaroModule-placeholder-text">
            你尚未发布自己的解读
          </p>
          {isOwner && !this.showInterpretationInput && (
            <button
              className="Button Button--primary"
              disabled={this.loading['interpretation']}
              onclick={() => { this.showInterpretationInput = true; m.redraw(); }}
            >
              <i className="fas fa-feather-alt"></i> 发布解读
            </button>
          )}
          {isOwner && this.showInterpretationInput && this.renderInterpretationEditor(taroCase, null)}
        </div>
      );
    }

    // --- 有解读但内容被隐藏（权限） ---
    const content = interpretation.attribute('content');
    if (!content) {
      return (
        <div className="TaroModule-private-notice">
          <i className="fas fa-lock"></i> 仅对案主、导师、辅导员可见
        </div>
      );
    }

    // --- 编辑模式 ---
    if (isOwner && this.showInterpretationEdit) {
      return (
        <div className="TaroModule-content">
          <h3 className="TaroModule-subtitle" style="font-size:15px;color:var(--heading-color);margin:0 0 8px;">
            <i className="fas fa-pen-fancy" style="margin-right:6px;"></i>编辑我的解读
          </h3>
          {this.renderInterpretationEditor(taroCase, interpretation)}
        </div>
      );
    }

    // --- 解读展示模式 ---
    return (
      <div className="TaroModule-content">
        <h3 className="TaroModule-subtitle" style="font-size:15px;color:var(--heading-color);margin:0 0 8px;display:flex;align-items:center;gap:8px;">
          <i className="fas fa-pen-fancy"></i>我的解读
          {isLocked && (
            <span className="Badge Badge--locked" style="font-size:11px;background:#e8e8e8;color:#888;padding:2px 8px;border-radius:10px;">
              <i className="fas fa-lock"></i> 已锁定
            </span>
          )}
        </h3>
        <Markdown text={content} />
        <div className="TaroModule-meta" style="display:flex;justify-content:space-between;align-items:center;">
          <small>发布于 {interpretation.createdAt().toLocaleString()}</small>
          {isLocked && (
            <small style="color:#999;">
              <i className="fas fa-lock"></i> 导师已点评，解读已锁定
            </small>
          )}
        </div>

        {/* 操作按钮：编辑/删除（仅案主 + 未锁定） */}
        {isOwner && !isLocked && (
          <div className="TaroInlineInput-actions" style="margin-top:10px;display:flex;gap:8px;">
            <button
              className="Button"
              disabled={this.loading['interpretation']}
              onclick={() => {
                this.interpretationInput = interpretation.attribute('content') || '';
                this.showInterpretationEdit = true;
                m.redraw();
              }}
            >
              <i className="fas fa-edit"></i> 编辑
            </button>
            <button
              className="Button Button--danger"
              disabled={this.loading['delete-interpretation']}
              onclick={() => this.deleteInterpretation(taroCase)}
            >
              {this.loading['delete-interpretation'] ? <i className="fas fa-spinner fa-pulse"></i> : <i className="fas fa-trash"></i>}
              {' '}删除
            </button>
          </div>
        )}

        {/* 未锁定提示 */}
        {isOwner && !isLocked && this.hasMentorReview && (
          <p style="font-size:12px;color:#999;margin-top:8px;">
            <i className="fas fa-info-circle"></i> 导师点评后解读将自动锁定，届时不可再编辑
          </p>
        )}
      </div>
    );
  }

  /** 共享的 Markdown 解读编辑器（使用独立 TaroMarkdownEditor 组件） */
  renderInterpretationEditor(taroCase, interpretation) {
    const isEdit = !!interpretation;
    return (
      <TaroMarkdownEditor
        value={this.interpretationInput}
        oninput={(text) => { this.interpretationInput = text; m.redraw(); }}
        disabled={this.loading['interpretation']}
        loading={this.loading['interpretation']}
        submitLabel={isEdit ? '保存修改' : '发布解读'}
        onsubmit={() => this.submitInterpretation(taroCase)}
        oncancel={() => {
          this.showInterpretationInput = false;
          this.showInterpretationEdit = false;
          this.interpretationInput = '';
          m.redraw();
        }}
      />
    );
  }

  submitInterpretation(taroCase) {
    const content = this.interpretationInput.trim();
    if (!content) return;

    this.setLoading('interpretation', true);
    app
      .request({
        method: 'POST',
        url: this.apiUrl('/taro/cases/' + taroCase.id() + '/interpretation'),
        body: {
          data: {
            type: 'taro-case-interpretations',
            attributes: { content },
          },
        },
      })
      .then(() => {
        this.setLoading('interpretation', false);
        this.showInterpretationInput = false;
        this.showInterpretationEdit = false;
        this.interpretationInput = '';
        return app.store.find('taro-cases', taroCase.id(), { include: 'aiReport,interpretation,mentorReview,feedbacks' });
      })
      .then(() => m.redraw())
      .catch((err) => {
        this.setLoading('interpretation', false);
        this.handleError(err);
      });
  }

  deleteInterpretation(taroCase) {
    if (!window.confirm('确定删除你的解读吗？此操作不可撤销。')) return;

    this.setLoading('delete-interpretation', true);
    app
      .request({
        method: 'DELETE',
        url: this.apiUrl('/taro/cases/' + taroCase.id() + '/interpretation'),
      })
      .then(() => {
        this.setLoading('delete-interpretation', false);
        return app.store.find('taro-cases', taroCase.id(), { include: 'aiReport,interpretation,mentorReview,feedbacks' });
      })
      .then(() => {
        this.showInterpretationEdit = false;
        this.interpretationInput = '';
        m.redraw();
      })
      .catch((err) => {
        this.setLoading('delete-interpretation', false);
        this.handleError(err);
      });
  }

  renderMentorSection(user, taroCase, mentorReview, followUps) {
    const isOwner = user && String(user.id()) === String(taroCase.userId());
    const isMentor = user && String(user.id()) === String(taroCase.assignedMentorId());
    const hasInterpretation = !!taroCase.interpretation();
    const hasAssignedMentor = !!taroCase.assignedMentorId();

    return (
      <div className="TaroMentorSection" style={{ borderTop: '1px solid #e8ecf0', marginTop: '12px', paddingTop: '12px' }}>
        {/* 导师点评内容 */}
        {mentorReview && mentorReview.attribute('content') ? (
          <div className="TaroModule-content">
            <h3 className="TaroModule-subtitle" style="font-size:15px;color:var(--heading-color);margin:0 0 8px;">
              <i className="fas fa-chalkboard-teacher" style="margin-right:6px;"></i>导师点评
            </h3>
            <Markdown text={mentorReview.attribute('content')} />
            <div className="TaroModule-meta">
              <small>点评于 {mentorReview.createdAt().toLocaleString()}</small>
            </div>
          </div>
        ) : (
          <div className="TaroModule-placeholder">
            <p className="TaroModule-placeholder-text">
              {mentorReview ? '导师点评仅对案主、导师、辅导员可见' : '导师尚未点评'}

            </p>
            {/* 案主申请导师点评 */}
            {isOwner && !mentorReview && hasInterpretation && !this.mentorReviewRequested && !this.loading['request-mentor-review'] && (
              <div>
                <button
                  className="Button Button--primary"
                  disabled={this.loading['request-mentor-review']}
                  onclick={() => {
                    if (!hasAssignedMentor) {
                      alert('你还没有老师，无法申请导师点评，请尽快给自己找个老师吧');
                      return;
                    }
                    this.requestMentorReview(taroCase);
                  }}
                  style="margin-bottom:6px;"
                >
                  <i className="fas fa-chalkboard-teacher"></i> 请导师点评
                </button>
                <p style="font-size:12px;color:#999;margin:0;">
                  <i className="fas fa-info-circle"></i> 导师点评后你的解读将自动锁定，不可再编辑
                </p>
              </div>
            )}
            {isOwner && this.mentorReviewRequested && !mentorReview && (
              <p style={{ fontSize: '13px', color: '#888', marginTop: '4px' }}>
                <i className="fas fa-check-circle" style="color:#4CAF50;"></i> 已向导师发送点评请求，请耐心等待
              </p>
            )}
            {/* 导师发布点评 */}
            {isMentor && !mentorReview && !this.showMentorReviewInput && (
              <button
                className="Button"
                disabled={this.loading['mentor-review']}
                onclick={() => { this.showMentorReviewInput = true; m.redraw(); }}
              >
                发布导师点评
              </button>
            )}
            {isMentor && !mentorReview && this.showMentorReviewInput && (
              <div className="TaroInlineInput">
                <textarea
                  className="FormControl"
                  rows={4}
                  placeholder="请输入导师点评内容（支持 Markdown）..."
                  value={this.mentorReviewInput}
                  oninput={(e) => { this.mentorReviewInput = e.target.value; }}
                  disabled={this.loading['mentor-review']}
                />
                <div className="TaroInlineInput-actions" style="margin-top:8px;display:flex;gap:8px;">
                  <button
                    className="Button Button--primary"
                    disabled={this.loading['mentor-review'] || !this.mentorReviewInput.trim()}
                    onclick={() => this.submitMentorReview(taroCase)}
                  >
                    {this.loading['mentor-review'] ? '提交中...' : '发布点评'}
                  </button>
                  <button
                    className="Button"
                    disabled={this.loading['mentor-review']}
                    onclick={() => { this.showMentorReviewInput = false; this.mentorReviewInput = ''; m.redraw(); }}
                  >
                    取消
                  </button>
                </div>
              </div>
            )}
          </div>
        )}

        {/* 导师追问（仅点评后可看到） */}
        {!!mentorReview && this.renderMentorFollowUps(user, taroCase, followUps)}
      </div>
    );
  }

  renderMentorFollowUps(user, taroCase, followUps) {
    const isOwner = user && String(user.id()) === String(taroCase.userId());
    const isMentor = user && String(user.id()) === String(taroCase.assignedMentorId());
    const hasInterpretation = !!taroCase.interpretation();
    const mentorReview = taroCase.mentorReview();

    // 只显示导师追问（过滤掉 AI 追问）
    const mentorFollowUps = followUps.filter((f) => f && f.attribute && f.attribute('target_type') === 'mentor');

    return (
      <div className="TaroMentorFollowUps" style={{ borderTop: '1px solid #e8ecf0', marginTop: '12px', paddingTop: '12px' }}>
        <h4 style={{ margin: '0 0 10px', fontSize: '14px', color: '#555', display: 'flex', alignItems: 'center', gap: '6px' }}>
          <i className="fas fa-question-circle"></i>
          导师追问（{mentorFollowUps.length}）
        </h4>

        {mentorFollowUps.length === 0 && (
          <p className="TaroModule-placeholder-text" style="font-size:13px;">暂无导师追问</p>
        )}

        {mentorFollowUps.slice().sort((a, b) => b.createdAt() - a.createdAt()).map((f) => {
          const id = f.id();
          const question = f.attribute('question');
          const answer = f.attribute('answer');
          const isExpanded = this._expandedMentorFollowUp === id;
          return (
            <div key={id} className="TaroModule-followUp" style={{ marginBottom: '8px', border: '1px solid #e8ecf0', borderRadius: '8px', overflow: 'hidden' }}>
              {/* 问题栏（可点击展开/折叠） */}
              <div
                className="TaroModule-followUpQuestion"
                onclick={() => {
                  this._expandedMentorFollowUp = isExpanded ? null : id;
                  m.redraw();
                }}
                style={{ padding: '10px 14px', background: '#f5f7fa', cursor: 'pointer', display: 'flex', alignItems: 'center', gap: '8px', fontSize: '14px', userSelect: 'none' }}
              >
                <span style={{ color: '#555', fontWeight: '600', whiteSpace: 'nowrap' }}>Q:</span>
                <span style={{ flex: 1, color: '#333' }}>{question}</span>
                <span style={{ color: '#999', fontSize: '12px', transition: 'transform 0.2s', transform: isExpanded ? 'rotate(180deg)' : 'none' }}>
                  <i className="fas fa-chevron-down"></i>
                </span>
              </div>
              {/* 答案（展开时显示） */}
              {isExpanded && answer && (
                <div className="TaroModule-followUpAnswer" style={{ padding: '10px 14px 10px 32px', background: '#f0fae6', fontSize: '14px', lineHeight: '1.7', borderTop: '1px solid #e8ecf0' }}>
                  <span style={{ color: '#4CAF50', fontWeight: '600' }}>A:</span>
                  <div style={{ marginTop: '4px', color: '#444' }}>{answer}</div>
                </div>
              )}
              {isExpanded && !answer && (
                <div style={{ padding: '10px 14px 10px 32px', fontSize: '13px', color: '#999', borderTop: '1px solid #e8ecf0' }}>
                  等待导师回答…
                </div>
              )}
              {/* 导师回答按钮 */}
              {isMentor && !answer && this.showAnswerInputFor !== id && (
                <button className="Button" disabled={this.loading['answer-follow-up-' + id]}
                  onclick={() => { this.showAnswerInputFor = id; this.answerInput = ''; m.redraw(); }}
                  style="margin:6px 0 6px 14px;font-size:12px;">回答</button>
              )}
              {isMentor && !answer && this.showAnswerInputFor === id && (
                <div className="TaroInlineInput" style="padding:6px 14px 10px;">
                  <textarea className="FormControl" rows={3} placeholder="请输入回答内容..."
                    value={this.answerInput}
                    oninput={(e) => { this.answerInput = e.target.value; }}
                    disabled={this.loading['answer-follow-up-' + id]} />
                  <div className="TaroInlineInput-actions" style="margin-top:6px;display:flex;gap:8px;">
                    <button className="Button Button--primary"
                      disabled={this.loading['answer-follow-up-' + id] || !this.answerInput.trim()}
                      onclick={() => this.answerFollowUp(taroCase, f)}>
                      {this.loading['answer-follow-up-' + id] ? '提交中...' : '提交回答'}
                    </button>
                    <button className="Button" disabled={this.loading['answer-follow-up-' + id]}
                      onclick={() => { this.showAnswerInputFor = null; this.answerInput = ''; m.redraw(); }}>取消</button>
                  </div>
                </div>
              )}
            </div>
          );
        })}

        {/* 案主提问（仅在有解读 + 有导师点评时可用，UI 与 AI 追问一致） */}
        {isOwner && hasInterpretation && !!mentorReview && (
          <div style={{ display: 'flex', gap: '8px', alignItems: 'center', marginTop: '10px' }}>
            <input
              className="FormControl"
              type="text"
              placeholder="输入你想向导师追问的内容…"
              value={this.followUpQuestionInput}
              disabled={this.loading['follow-up']}
              onkeydown={(e) => {
                if (e.key === 'Enter' && !e.shiftKey) {
                  e.preventDefault();
                  this.askFollowUp(taroCase);
                }
              }}
              oninput={(e) => { this.followUpQuestionInput = e.target.value; }}
              style={{ flex: 1, fontSize: '14px', borderRadius: '20px', padding: '7px 14px' }}
            />
            <button
              className="Button"
              style={{ backgroundColor: '#2196F3', borderColor: '#2196F3', color: '#fff', borderRadius: '50%', width: '36px', height: '36px', padding: 0 }}
              disabled={this.loading['follow-up'] || !this.followUpQuestionInput.trim()}
              onclick={() => this.askFollowUp(taroCase)}
            >
              {this.loading['follow-up'] ? <i className="fas fa-spinner fa-pulse"></i> : <i className="fas fa-paper-plane"></i>}
            </button>
          </div>
        )}
        {isOwner && !hasInterpretation && (
          <p style={{ fontSize: '12px', color: '#999', marginTop: '6px' }}>
            <i className="fas fa-info-circle"></i> 请先发布你的解读，再向导师提问
          </p>
        )}
        )}
      </div>
    );
  }

  submitMentorReview(taroCase) {
    const content = this.mentorReviewInput.trim();
    if (!content) return;

    this.setLoading('mentor-review', true);
    app
      .request({
        method: 'POST',
        url: this.apiUrl('/taro/cases/' + taroCase.id() + '/mentor-review'),
        body: {
          data: {
            type: 'taro-case-mentor-reviews',
            attributes: { content },
          },
        },
      })
      .then(() => {
        this.setLoading('mentor-review', false);
        this.showMentorReviewInput = false;
        this.mentorReviewInput = '';
        return app.store.find('taro-cases', taroCase.id(), { include: 'aiReport,interpretation,mentorReview,feedbacks' });
      })
      .then(() => m.redraw())
      .catch((err) => {
        this.setLoading('mentor-review', false);
        this.handleError(err);
      });
  }

  requestMentorReview(taroCase) {
    this.setLoading('request-mentor-review', true);
    app
      .request({
        method: 'POST',
        url: this.apiUrl('/taro/cases/' + taroCase.id() + '/request-mentor-review'),
      })
      .then(() => {
        this.setLoading('request-mentor-review', false);
        this.mentorReviewRequested = true;
        m.redraw();
      })
      .catch((err) => {
        this.setLoading('request-mentor-review', false);
        this.handleError(err);
      });
  }

  askFollowUp(taroCase) {
    const question = this.followUpQuestionInput.trim();
    if (!question) return;

    this.setLoading('follow-up', true);
    app
      .request({
        method: 'POST',
        url: this.apiUrl('/taro/cases/' + taroCase.id() + '/follow-ups'),
        body: {
          data: {
            type: 'taro-case-follow-ups',
            attributes: { question, target_type: 'mentor' },
          },
        },
      })
      .then(() => {
        this.setLoading('follow-up', false);
        this.showFollowUpQuestionInput = false;
        this.followUpQuestionInput = '';
        return app.store.find('taro-cases', taroCase.id(), { include: 'aiReport,interpretation,mentorReview,followUps,feedbacks' });
      })
      .then(() => m.redraw())
      .catch((err) => {
        this.setLoading('follow-up', false);
        this.handleError(err);
      });
  }

  answerFollowUp(taroCase, followUp) {
    const answer = this.answerInput.trim();
    if (!answer) return;

    this.setLoading('answer-follow-up-' + followUp.id(), true);
    app
      .request({
        method: 'PATCH',
        url: this.apiUrl('/taro/cases/' + taroCase.id() + '/follow-ups/' + followUp.id()),
        body: {
          data: {
            type: 'taro-case-follow-ups',
            attributes: { answer },
          },
        },
      })
      .then(() => {
        this.setLoading('answer-follow-up-' + followUp.id(), false);
        this.showAnswerInputFor = null;
        this.answerInput = '';
        return app.store.find('taro-cases', taroCase.id(), { include: 'aiReport,interpretation,mentorReview,followUps,feedbacks' });
      })
      .then(() => m.redraw())
      .catch((err) => {
        this.setLoading('answer-follow-up-' + followUp.id(), false);
        this.handleError(err);
      });
  }

  // ============================================================
  // 板块 3：反馈信息
  // ============================================================
  renderFeedback(user, taroCase, feedbacks) {
    const isOwner = user && String(user.id()) === String(taroCase.userId());
    // 按时间从早到晚排列
    const sorted = feedbacks.length ? feedbacks.slice().sort((a, b) => a.createdAt() - b.createdAt()) : [];

    return (
      <div className="TaroModule-feedbackWrap">
        {/* 反馈列表 */}
        {sorted.length > 0 ? (
          <div className="TaroModule-feedbackList">
            {sorted.map((fb) => (
              <div className="TaroModule-feedbackItem" key={fb.id()} style={{ padding: '10px 0', borderBottom: '1px solid #f0f0f0' }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '4px' }}>
                  <small style={{ color: '#999', fontSize: '12px' }}>{fb.createdAt().toLocaleString()}</small>
                  {isOwner && (
                    <button className="Button Button--link" style={{ fontSize: '12px', padding: '2px 6px', color: '#e74c3c' }}
                      disabled={this.loading['delete-feedback-' + fb.id()]}
                      onclick={() => this.deleteFeedback(taroCase, fb)}>
                      <i className="fas fa-trash"></i>
                    </button>
                  )}
                </div>
                {fb.attribute('content') ? (
                  <div style={{ fontSize: '14px', lineHeight: '1.7', color: '#333' }}>{fb.attribute('content')}</div>
                ) : null}
              </div>
            ))}
          </div>
        ) : (
          <p className="TaroModule-placeholder-text">暂无反馈信息</p>
        )}

        {/* 发布反馈按钮（始终在模块内显示） */}
        {isOwner && !this.showFeedbackInput && (
          <button className="Button Button--primary" style="margin-top:10px;"
            onclick={() => { this.showFeedbackInput = true; m.redraw(); }}>
            <i className="fas fa-star"></i> 发布反馈
          </button>
        )}

        {/* 反馈输入 */}
        {isOwner && this.showFeedbackInput && (
          <div className="TaroInlineInput" style={sorted.length > 0 ? 'margin-top:12px;' : 'margin-top:8px;'}>
            <textarea
              className="FormControl"
              rows={3}
              placeholder="请输入你的反馈内容…"
              value={this.feedbackContent}
              oninput={(e) => { this.feedbackContent = e.target.value; }}
              disabled={this.loading['feedback']}
            />
            <div className="TaroInlineInput-actions" style="margin-top:8px;display:flex;gap:8px;">
              <button className="Button Button--primary"
                disabled={this.loading['feedback'] || !this.feedbackContent.trim()}
                onclick={() => this.submitFeedback(taroCase)}>
                {this.loading['feedback'] ? '提交中...' : '提交反馈'}
              </button>
              <button className="Button" disabled={this.loading['feedback']}
                onclick={() => { this.showFeedbackInput = false; this.feedbackContent = ''; m.redraw(); }}>
                取消
              </button>
            </div>
          </div>
        )}
      </div>
    );
  }

  submitFeedback(taroCase) {
    const content = this.feedbackContent.trim();
    const rating = parseInt(this.feedbackRating, 10) || 5;

    this.setLoading('feedback', true);
    app
      .request({
        method: 'POST',
        url: this.apiUrl('/taro/cases/' + taroCase.id() + '/feedback'),
        body: {
          data: {
            type: 'taro-case-feedbacks',
            attributes: { content, rating },
          },
        },
      })
      .then(() => {
        this.setLoading('feedback', false);
        this.showFeedbackInput = false;
        this.feedbackContent = '';
        this.feedbackRating = '5';
        return app.store.find('taro-cases', taroCase.id(), { include: 'aiReport,interpretation,mentorReview,feedbacks' });
      })
      .then(() => m.redraw())
      .catch((err) => {
        this.setLoading('feedback', false);
        this.handleError(err);
      });
  }

  deleteFeedback(taroCase, fb) {
    if (!window.confirm('确定删除这条反馈吗？')) return;

    this.setLoading('delete-feedback-' + fb.id(), true);
    app
      .request({
        method: 'DELETE',
        url: this.apiUrl('/taro/cases/' + taroCase.id() + '/feedback/' + fb.id()),
      })
      .then(() => {
        this.setLoading('delete-feedback-' + fb.id(), false);
        return app.store.find('taro-cases', taroCase.id(), { include: 'aiReport,interpretation,mentorReview,feedbacks' });
      })
      .then(() => m.redraw())
      .catch((err) => {
        this.setLoading('delete-feedback-' + fb.id(), false);
        this.handleError(err);
      });
  }

  renderRating(rating) {
    if (!rating) return null;
    const stars = [];
    for (let i = 1; i <= 5; i++) {
      stars.push(
        <i key={i} className={'fas fa-star' + (i <= rating ? '' : ' TaroModule-star--empty')}></i>
      );
    }
    return <span className="TaroModule-stars">{stars}</span>;
  }
}
